import { t } from '@lingui/macro'
import { useTaskTemplates } from 'context'
import { FlexAlignItemsCenter, Loading } from 'webbook-airways'
import { Select } from './Select'

export default function InputFieldTasks({
  value,
  onChange,
  required,
  withoutAll,
  disabled,
  noBorder = true,
}) {
  const { loading, taskTemplates } = useTaskTemplates()

  if (loading) {
    return (
      <FlexAlignItemsCenter css={{ justifyContent: 'center', minWidth: 100 }}>
        <Loading size={20} container={false} noTimeout />
      </FlexAlignItemsCenter>
    )
  }

  return (
    <Select
      value={value ? `${value}` : undefined}
      onChange={onChange}
      options={taskTemplates.map((taskTemplate) => ({
        value: `${taskTemplate.task_template_id}`,
        label: taskTemplate.name,
      }))}
      label={t`Task`}
      required={required}
      placeholder={t`Choose task`}
      noBorder={noBorder}
      disabled={disabled}
      withoutAll={withoutAll}
    />
  )
}
